import React from "react";
import {  Col,Typography, } from "antd";
import NotFoundUrl from "assets/Images/notfound.png";
import LazyLoadImage from "./LazyLoadImage";
import { MazakaButton } from "./MazakaButton";
import { HomeOutlined } from "@ant-design/icons";

const NotFound: React.FC = () => {
  const {Text} = Typography
  return (
    <>
      
      <Col xs={24} className=" !h-screen !flex items-center justify-center !bg-[#dee4e6]  ">
<div className="!grid gap-2">

      <LazyLoadImage
      wrapperWidth="900px"
      wrapperHeight="500px"
      classNames="!w-full lg:!w-[900px]"
      src={NotFoundUrl}
      alt=""
      style={{Object:"contain"}}
      />
      <div className="!flex justify-center">
        <Text className="!text-xl md:!text-4xl !font-bold !text-[#162b3d]">Sayfa Bulunamadı</Text>
      </div>
      <div className="!flex justify-center">
        <Text className="!text-[#446179] !text-lg  md:!text-2xl" >Aradığınız İlan Çoktan Satılmış Olabilir</Text>
      </div>
      <div className="!flex justify-center ">
        <MazakaButton icon={<HomeOutlined/>} type="primary" size="large" className="!px-8 !text-white !bg-black" >
          Ana Sayfaya Dön
        </MazakaButton>
      </div>
</div>


        
      </Col>

   

     
    </>
  );
};

export default NotFound;
